import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSimDeclarationStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_80 = _tokens$spacing.SPACING_80;
  return StyleSheet.create({
    reasonDropdown: {
      marginTop: SPACING_16
    },
    simOwnerDetailsTopDivider: {
      marginVertical: SPACING_16,
      marginHorizontal: -SPACING_16,
      width: 'auto'
    },
    simOwnerDetailsBottomDivider: {
      marginTop: SPACING_8,
      marginHorizontal: -SPACING_16,
      width: 'auto'
    },
    providerNameInput: {
      flex: 1
    },
    noOfSimInput: {
      width: SPACING_80,
      marginLeft: SPACING_16
    },
    connectionsCountInput: {
      zIndex: 10000
    },
    addProviderBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: SPACING_16
    },
    providerContent: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: SPACING_16
    }
  });
};